import { agreementOptionKey } from '~/components/BillModal/components/BillItemsTable/ItemServiceSelect/itemServiceSelect.utils';
export const ADD_CHARGE_AGREEMENT_HEADER_ID = 'add-charge-agreement-header';
export const ADD_CHARGE_OUT_OF_SCOPE_HEADER_ID = 'add-charge-out-of-scope-header';
const sectionHeader = (id, label)=>({
        id,
        isSectionHeader: true,
        label
    });
const agreementItem = (option)=>({
        id: agreementOptionKey(option),
        title: option.name,
        subtext: option.costString,
        disabled: option.disabledReason.isDisabled,
        tooltip: option.disabledReason.isDisabled ? option.disabledReason.reasonTooltip : undefined,
        bi: {
            name: 'add_service_from_agreement',
            data: {
                serviceId: option.id
            }
        }
    });
const templateItem = (template, costString)=>({
        id: template.id,
        title: template.name,
        subtext: costString,
        bi: {
            name: 'add_service_from_template',
            data: {
                serviceId: template.id
            }
        }
    });
export function toGroupedMenuItems(params) {
    const { agreementOptions, outOfScopeTemplates, texts, formatTemplateCost, flat = false } = params;
    const agreementEntries = agreementOptions.map(agreementItem);
    const outOfScopeEntries = outOfScopeTemplates.map((template)=>templateItem(template, formatTemplateCost(template)));
    if (flat) {
        return [
            ...agreementEntries,
            ...outOfScopeEntries
        ];
    }
    const agreementSection = agreementEntries.length > 0 ? [
        sectionHeader(ADD_CHARGE_AGREEMENT_HEADER_ID, texts.inAgreementSectionLabel),
        ...agreementEntries
    ] : [];
    const outOfScopeSection = outOfScopeEntries.length > 0 ? [
        sectionHeader(ADD_CHARGE_OUT_OF_SCOPE_HEADER_ID, texts.outOfScopeSectionLabel),
        ...outOfScopeEntries
    ] : [];
    return [
        ...agreementSection,
        ...outOfScopeSection
    ];
}
